<template>
  <div
    class="modal fade"
    id="file_comment_modal"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg">
      <div
        :class="`modal-content bg-${getColorMode.background} text-${getColorMode.text}`"
      >
        <div
          :class="`modal-header bg-${getColorMode.globalBackground} text-${getColorMode.text} border-0`"
        >
          <h5 class="modal-title" id="exampleModalLabel">
            Comentarios {{ fileName }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body p-0">
          <div class="chat">
            <div class="chat-history">
              <ul v-if="comments" class="list-style-none">
                {{
                  (currentDate = null)
                }}
                <li
                  class="clearfix"
                  v-for="comment in comments"
                  v-bind:key="comment.id"
                >
                  <!-- <div class="text-center fw-bold" v-if="currentDate !== $dayjs(comment.created_at).format('DD-MM-YYYY')">
                                        {{currentDate = $dayjs(comment.created_at).format('DD-MM-YYYY')}}
                                      </div> -->
                  <div v-if="user.id == comment.user_id" class="my-4">
                    <div class="message-data align-right">
                      <table class="ms-auto">
                        <tr>
                          <td>
                            <span span class="message-data-name me-2 fw-bold"
                              >Yo</span
                            >
                          </td>
                          <td>
                            <img
                              :src="userImage"
                              alt=""
                              width="45"
                              height="45"
                              class="rounded-circle me-3"
                            />
                          </td>
                        </tr>
                      </table>
                    </div>
                    <div class="message other-message float-right my-0">
                      {{ comment.message }}
                    </div>
                    <!-- <div class="message-data-time ts-sm clearfix text-end mt-1">{{$dayjs(comment.created_at).format('HH:mm')}}</div> -->
                  </div>
                  <div v-else class="my-4">
                    <div class="message-data">
                      <table>
                        <tr>
                          <td>
                            <img
                              :src="userImage"
                              alt=""
                              width="45"
                              height="45"
                              class="rounded-circle ms-3"
                            />
                          </td>
                          <td>
                            <span span class="message-data-name ms-2 fw-bold">{{
                              comment.user.name
                            }}</span>
                          </td>
                        </tr>
                      </table>
                    </div>
                    <div class="message my-message my-0">
                      {{ comment.message }}
                    </div>
                    <!-- <div class="message-data-time clearfix ts-sm mt-1">{{$dayjs(comment.created_at).format('HH:mm')}}</div> -->
                  </div>
                </li>
              </ul>
            </div>
            <div
              :class="`chat-message clearfix bg-${getColorMode.globalBackground} text-${getColorMode.text}`"
            >
              <div class="input-group">
                <textarea
                  class="form-control"
                  name="message-to-send"
                  v-model="textBox"
                  placeholder="Escribe un mensaje"
                  rows="1"
                ></textarea>
                <button class="btn btn-primary btn-lg" @click="sendMessage()">
                  Enviar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { Modal } from "bootstrap";
export default {
  name: "FileComments",
  emits: ["closeModal"],
  props: {
    projectId: { type: Number, default: 0 },
    folderId: { type: Number, default: 0 },
    fileName: { type: String, default: "" },
    fileId: { type: Number, default: 0 },
    folderFileId: { type: Number, default: 0 },
  },
  data() {
    return {
      modal: null,
      comments: [],
      textBox: null,
      moment: null,
      currentDate: null,
      userImage: require("@/assets/images/general/user.png"),
    };
  },
  mounted() {
    this.get_comments();
    let app = this;
    this.modal = new Modal(document.getElementById("file_comment_modal"), {});
    this.modal.show();
    document
      .getElementById("file_comment_modal")
      .addEventListener("hide.bs.modal", function () {
        app.$emit("closeModal");
      });
  },
  computed: {
    ...mapGetters("general", ["getColorMode"]),
    user() {
      return this.$auth.user();
    },
  },
  methods: {
    get_comments() {
      this.axios
        .get(
          `projects/${this.projectId}/folders/${this.folderId}/files/${this.fileId}/get_comments`
        )
        .then((result) => {
          this.comments = result.data.body;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    sendMessage() {
      this.axios
        .post(
          `projects/${this.projectId}/folders/${this.folderId}/files/${this.fileId}/comments`,
          { comment: { message: this.textBox } }
        )
        .then((result) => {
          this.comments.push(result.data.body);
          this.textBox = null;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
